<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ label }}</span>
		<div class="search-option-wrapper__normal" style="width: 300px">
			<el-radio v-model="radio" v-for="(mmPrvs, index) in mmPrvsList" :key="index" :label="mmPrvs.commCd" @change="change">{{
				mmPrvs.commCdName
			}}</el-radio>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcmClam/store/helpers';
export default {
	props: ['label', 'paramKey'],
	data() {
		return {
			radio: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'mmPrvs', value: value }).then(() => {});
			this.$emit('searchList');
		},
		processInfo() {
			this.radio = this.searchParams.mmPrvs;
		}
	},
	created() {
		if (this.searchParams.mmPrvs == null || this.searchParams.mmPrvs == '') this.searchParams.mmPrvs = '';
		this.radio = this.searchParams.mmPrvs;
	}
};
</script>

<style></style>
